import { syncState } from '@tahi/db';
import { eq } from 'drizzle-orm';
import type { LocalDb } from './localDb';
import { emitTables } from './tableBus';

export async function getState(db: LocalDb, key: string): Promise<string | null> {
  const row = await db
    .select({ value: syncState.value })
    .from(syncState)
    .where(eq(syncState.key, key))
    .get();
  return row?.value ?? null;
}

/** Unexecuted query, so it can go inside a db.batch(). */
export function setStateQuery(db: LocalDb, key: string, value: string) {
  return db
    .insert(syncState)
    .values({ key, value })
    .onConflictDoUpdate({ target: syncState.key, set: { value } });
}

export async function setState(db: LocalDb, key: string, value: string): Promise<void> {
  await setStateQuery(db, key, value);
  emitTables(['sync_state']);
}

export async function clearState(db: LocalDb, key: string): Promise<void> {
  await db.delete(syncState).where(eq(syncState.key, key));
  emitTables(['sync_state']);
}
